module.exports = __webpack_public_path__ + "static/media/lr.1ae79265.svg";